<span
  [innerHTML]="
    'bezugsrecht-announcement-list-item.wahldividende.hint'
      | transloco
        : {
            name: announcement.bestandAktieBezeichnung,
            isin: announcement.bestandAktieIsin,
            expirationDate: (announcement.letzterWeisungstermin | date: 'dd.MM.yyyy H:mm'),
            shareName: announcement.bezugAktieBezeichnung,
            shareIsin: announcement.bezugAktieIsin,
          }
  "
>
</span>
<a class="link-primary link-underline" [routerLink]="wahldividendeRoute + '/' + announcement.bzrIsin">{{
  'bezugsrecht-announcement-list-item.link' | transloco
}}</a>
